import { render, staticRenderFns } from "./ClinicPrefsEditNotifications.vue?vue&type=template&id=6ebb1f3e&scoped=true"
import script from "./ClinicPrefsEditNotifications.vue?vue&type=script&lang=js"
export * from "./ClinicPrefsEditNotifications.vue?vue&type=script&lang=js"
import style0 from "./ClinicPrefsEditNotifications.vue?vue&type=style&index=0&id=6ebb1f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebb1f3e",
  null
  
)

export default component.exports